import { NotificationParams, useApiErrorNotification } from "@material-dev/insights-portal-ui-components";
import { useCallback } from "react";
import { EmailNotificationClient, IEmailNotificationClient } from "app/SharedApiClient";
import { BASE_SHARED_API_URL } from "const/baseUrl";
import { getLocalEnvironment } from "utils";

const API_ERROR_TITLE = "DataManager App: API error";
const MESSAGE_TEXT = "There was an error with the DataManager API, please";

const emailNotificationClient: IEmailNotificationClient = new EmailNotificationClient(BASE_SHARED_API_URL);

const useEncodingApiErrorListener = () => {
  const handleNotificationSend = useCallback(
    async ({ currentUser, errorMessage, request, response, url = "" }: NotificationParams) => {
      const command = {
        title: API_ERROR_TITLE,
        environment: getLocalEnvironment(),
        additionalProps: {
          "Name of user": String(currentUser),
          url,
          request,
          response,
          errorMessage,
        },
      };

      console.error(command);
      try {
        await emailNotificationClient.sendExceptionNotification(command);
      } catch (error) {
        console.error(error);
      }
    },
    [],
  );

  useApiErrorNotification({
    messageText: MESSAGE_TEXT,
    onNotification: handleNotificationSend,
    emitNotification: false
  });
};

export default useEncodingApiErrorListener;
